<template>
    <div class="web-logo" :class="device" @click="setLargeCardId('None')">
        <img src="@/assets/small_logo.png" alt="logo"/>
        <div class="text" v-html="$t('web-title')"></div>
    </div>
</template>

<script>
import { mapMutations } from 'vuex'
export default {
    name: 'WebLogo',
    props: {
        device: {
            type: String,
            required: true,
        },
    },
    methods: {
        ...mapMutations(['setLargeCardId']),
    },
}
</script>

<style lang="scss" scoped>
.web-logo {
    cursor: pointer;
    display: flex;
}
.text {
    font-family: 'Iansui-Regular';
    display: flex;
    flex-direction: column;
    justify-content: center;
    text-align: left;
    font-weight: bold;
    white-space: nowrap;
}

.desktop {
    height: 92%;
    width: fit-content;
    max-height: max-content;
    margin: auto 20px;
    img {
        height: 100%;
        width: auto;
    }
    .text {
        margin-left: 10px;
        height: 100%;
        gap: 10%;

        font-size: 1.8rem;
        color: #302d2c;
        line-height: 3rem;
    }
}
.mobile {
    @media (orientation: landscape) {
        display: flex;
        justify-content: center;
        align-items: center;
        gap: 1rem;
        img {
            height: 80%;
            // width: 32%;
            // margin: 0.4rem auto;
        }

        .text {
            margin-left: 5px;
            gap: 0.5vh;
            font-size: 1.2rem;
            color: #302d2c;
        }
    }
    @media (orientation: portrait) {
        width: fit-content;
        display: flex;
        justify-content: center;
        align-items: center;
        img {
            // width: fit-content;
            height: 8vh;
            margin: 0.8rem 0;
        }
        .text {
            margin-left: 1.5vh;
            gap: 0.5vh;
            font-size: 2.5vh;
            color: #302d2c;
        }
    }
}
</style>
